export type RisorsaCalDav = {
  id?: number;
  coddip?: string;
  caldavUrl?: string;
  username?: string;
  passwordApp?: string;
  enabled?: boolean;
  hasPassword?: boolean;
  created?: Date | null;
  updated?: Date | null;
};

export type MiaRisorsaCalDav = {
  coddip?: string;
  nomedip?: string;
  caldavUrl?: string;
  username?: string;
  passwordApp?: string;
  enabled?: boolean;
};

export type RisorsaCalDavApiResponse = {
  results: Array<RisorsaCalDav>;
  count: number;
};

export function mapJsonToRisorsaCalDav(item: any): RisorsaCalDav {
  return {
    id: item.BT90_ID,
    coddip: item.BT90_CODDIP,
    caldavUrl: item.BT90_CALDAV_URL,
    username: item.BT90_USERNAME,
    enabled: item.BT90_ENABLED,
    hasPassword: item.hasPassword,
    created: item.BT90_CREATED ? new Date(item.BT90_CREATED) : null,
    updated: item.BT90_UPDATED ? new Date(item.BT90_UPDATED) : null,
  };
}

export function mapJsonToRisorsaCalDavApiResponse(jsonData: any): RisorsaCalDavApiResponse {
  return {
    count: jsonData.count,
    results: (jsonData.results ?? []).map(mapJsonToRisorsaCalDav),
  };
}

export function mapRisorsaCalDavToJson(item: RisorsaCalDav) {
  return {
    BT90_ID: item.id,
    BT90_CODDIP: item.coddip,
    BT90_CALDAV_URL: item.caldavUrl,
    BT90_USERNAME: item.username,
    BT90_ENABLED: item.enabled,
    passwordApp: item.passwordApp,
  };
}
